// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card[data-v-6d4664d7]{border-radius:0!important}", ""]);
// Exports
module.exports = exports;
